import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalNotifyService } from "src/app/core/services/modal-notify.service";
import { OperationsService } from "src/app/core/services/operations.service";
import { RoutingConfigurationUtilService } from "../../../../core/services/routing-configuration-util.service";
import { MappingTipiEntitaPratica } from "../../../configuration/mapping-tipi-entita-pratica";
import { NomiDescrittoriSezione } from "../../../configuration/nomi-descrittori-sezione";
import { DescrittoriSezioneHash } from "../../../interface/descrittori-sezione-hash";
import { FascicoloLight } from "../../../models/fascicolo/fascicolo-light";
import { fascicoliPCT } from "../../../models/mock/fascicoliPCT";
import { PraticaLight } from "../../../models/pratica/pratica-light";
import { ConfigurationService } from "src/app/common/configuration/services/configuration.service";
import { ConfigurationFeature } from "src/app/common/configuration/models/configuration";
import { DescrittoreSezione } from "src/app/common/models/descrittore-sezione";
import { AppData } from "src/app/data-store";
import { MappingTipiEntitaFascicolo } from "src/app/common/configuration/mapping-tipi-entita-fascicolo";
import { FascicoloFull } from "src/app/common/models/fascicolo/fascicolo-full";

@Component({
  selector: "ul [option-fascicolo]",
  templateUrl: "option-fascicolo.component.html",
})
export class OptionFascicoloComponent implements OnInit, OnChanges {
  @Input() fascicolo: FascicoloFull;
  @Input() pratica: PraticaLight;
  @Input() descrittori: DescrittoriSezioneHash;
  descrittoriSezione: DescrittoreSezione;
  @Output() onReturnMethodFascicoloOption: EventEmitter<any> =
    new EventEmitter<any>();

  keyDescrittoreDefinizione: string =
    NomiDescrittoriSezione.DESCRITTORE_DEFINIZIONE;
  keyDescrittoreRimozioneDefinizione: string =
    NomiDescrittoriSezione.DESCRITTORE_RIMOZIONE_DEFINIZIONE;
  keyDescrittoreRiunisciGiudizi: string =
    NomiDescrittoriSezione.DESCRITTORE_RIUNIONE_GIUDIZI;
  keyDescrittoreCancellazione: string =
    NomiDescrittoriSezione.DESCRITTORE_CANCELLAZIONE;
  keyDescrittoreRimozioneRiunione: string =
    NomiDescrittoriSezione.DESCRITTORE_RIMOZIONE_RIUNIONE_GIUDIZI;
  keyDescrittoreEstrazione: string =
    NomiDescrittoriSezione.DESCRITTORE_ESTRAZIONE;
  keyDescrittorePctDeposito: string =
    NomiDescrittoriSezione.DESCRITTORE_PCT_DEPOSITO;
  keyDescrittorePctConsultazione: string =
    NomiDescrittoriSezione.DESCRITTORE_PCT_CONSULTAZIONE;
  keyDescrittoreCopiaFascicolo: string =
    NomiDescrittoriSezione.DESCRITTORE_COPIA_FASCICOLO;
  keyDescrittoreGeneraDocumento: string =
    NomiDescrittoriSezione.DESCRITTORE_GENERAZIONE_DOCUMENTO;

  ID_PRATICA_PARERISTICA = MappingTipiEntitaPratica.PRATICA_PARERISTICA;

  private isViewFascicoloView: boolean = true;
  private isViewPCTDeposito: boolean = true;
  private isViewPCTConsultazione: boolean = true;
  private urlPathViewFascicolo: string;
  categoriaFascicolo: string;
  templateAssociati;

  constructor(
    private configService: ConfigurationService,
    private route: ActivatedRoute,
    private router: Router,
    private routingService: RoutingConfigurationUtilService,
    private service: OperationsService,
    private modalNotifyService: ModalNotifyService,
    protected operationsService: OperationsService,
  ) {}

  ngOnInit() {
    this.setRoutingVisualizzazioneFascicolo(this.fascicolo, this.pratica);
    this.getTipoFascicolo(this.fascicolo);
    this.descrittoriSezione = AppData.getInstance().descrittoriSezione;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!!changes.fascicolo || !!changes.pratica){
      this.setViewPct();
    }
  }

  getTipoFascicolo(fascicolo: FascicoloLight) {
    this.categoriaFascicolo = fascicolo.tipoFascicolo.categoria ? fascicolo.tipoFascicolo.categoria.id : null;
  }

  setRoutingVisualizzazioneFascicolo(
    fascicolo: FascicoloLight,
    pratica: PraticaLight
  ) {
    if (fascicolo && fascicolo.tipoFascicolo) {
      let urlViewFascicolo =
        "/" +
        this.routingService.checkStatoFascicoloAndGetRoutingPath(
          fascicolo,
          pratica.tipoPratica.id,
          fascicolo.tipoFascicolo.id
        ) +
        "/" +
        this.fascicolo.id;
      if (urlViewFascicolo === this.router.url) {
        this.isViewFascicoloView = false;
      } else {
        this.isViewFascicoloView = true;
      }
      this.urlPathViewFascicolo = urlViewFascicolo;
    }
  }

  

  setViewPct() {

    // Consultazione non disponibile
    this.isViewPCTConsultazione = false;

    if(this.configService.isFeatureEnabled(ConfigurationFeature.PCT) && this.routingService.isFascicoloInLavorazione(this.fascicolo)){
      let fascicoloPCT = fascicoliPCT.find(
        f =>
          f.idTipoFascicolo === this.fascicolo.tipoFascicolo.id &&
          f.idTipoPratica === this.pratica.tipoPratica.id
      );
      if (!!fascicoloPCT) {
        this.isViewPCTDeposito = fascicoloPCT.enabled === "all" || fascicoloPCT.enabled === "deposito";
        if(this.isViewPCTDeposito && fascicoloPCT.idTipoPratica === MappingTipiEntitaPratica.PRATICA_TRIBUTARIO){
            this.isViewPCTDeposito = this.enableConditionDepositoTributario();
        }
        // this.isViewPCTConsultazione = fascicoloPCT.enabled === "all" || fascicoloPCT.enabled === "consultazione";
        return;
      }
    }

    this.isViewPCTDeposito = false;
    // this.isViewPCTConsultazione = false;
  }
  
  enableConditionDepositoTributario(): boolean {
    if(this.fascicolo?.tipoFascicolo?.id === MappingTipiEntitaFascicolo.FASCICOLO_ORDINARIO){

      let autorita = this.fascicolo.autoritaGiudiziaria?.label?.toUpperCase();
      let isCassazione = autorita === 'CASSAZIONE';

      if (isCassazione) {
        console.log('Deposito PCT disponibile.');
        return true;
      }

    }

    console.log("Deposito PCT non disponibile.");
    return false;
  }

  onClickOption(
    method: string,
    fascicolo: FascicoloLight,
    pratica: PraticaLight
  ) {
    this.onReturnMethodFascicoloOption.emit({
      method,
      fascicolo,
      pratica,
    });
  }

  elemGeneraDocumento(fascicolo, pratica) {
    let idFascicolo = fascicolo.id;
    let idTipoPratica = pratica.tipoPratica.id;
    let idTipoFascicolo = fascicolo.tipoFascicolo.id;
    let idSezione;

    let tipopratica = pratica.intestazione.campi.tipoPratica.toLowerCase();
    let tipoFascicolo = fascicolo.tipoFascicolo.endpoint; // fascicolo.tipoFascicolo.descrizione.toLowerCase().replace(/\s/g, '')

    /*switch (tipoFascicolo) {
      case 'ricorsoinopposizione':
        tipoFascicolo = 'ricorsoopposizione';
      case 'ricorsoaltar':
        tipoFascicolo = 'ricorsotar';
      case 'ricorsoincassazione':
        tipoFascicolo = 'ricorsocassazione';
      case 'opposizionealdecretoingiuntivo':
        tipoFascicolo = 'opposizionedecretoingiuntivo';
      case "opposizioneall'esecuzione":
        tipoFascicolo = 'opposizioneesecuzione';
      case "sommariod'urgenza":
        tipoFascicolo = 'sommariourgenza';
      case 'esecuzionec/oterzi/':
        tipoFascicolo = 'esecuzionepressoterzi';
      case 'ricorsostraordinarioalpresidentedellarepubblica':
        tipoFascicolo = 'ricorsostraordinariopresidente';
    }*/

    this.service
      .getDettaglioFascicoloGenerico(tipopratica, tipoFascicolo, fascicolo.id)
      .subscribe((res) => {
        if (res.fascicolo.idSezioneDocumentazioneAllegata) {
          idSezione = res.fascicolo.idSezioneDocumentazioneAllegata;
        } else {
          idSezione = "new";
        }

        this.operationsService
          .getTemplateFascicolo(idTipoFascicolo)
          .subscribe((res2) => {
            if (res2.length == 0) {
              this.modalNotifyService.customMessage(
                "Non ci sono template associati per questa tipologia di fascicolo."
              );
            }
            /*
            else if (res2.length == 1) {
              let obj = {
                tipoFascicolo: tipoFascicolo.toUpperCase(),
                idFascicolo: idFascicolo,
                idSezione: idSezione,
                idTemplate: res2[0].idTemplate,
                anteprima: false
              };
              this.operationsService.generaDocumentoFascicolo(obj).subscribe();

              // this.operationsService.generaDocumento(obj).subscribe(res3 => {
              //   if (res3)
              //     this.modalNotifyService.customMessage('Operazione eseguita con successo! Il documento si trova nella sezione Documentazione Allegata del fascicolo.');
              // });
            }
            */
            else {
              sessionStorage.setItem(
                "backLink",
                window.location.hash.substring(1)
              );
              this.router.navigate([
                "/defineTemplate/" +
                tipopratica +
                "/" +
                tipoFascicolo +
                "/" +
                idFascicolo +
                "/" +
                idSezione +
                "/" +
                idTipoFascicolo,
              ]);
            }
          });
      });
  }

  isPctDepositoEnabled(): boolean {
    return this.isViewPCTDeposito && this.descrittori?.[this.keyDescrittorePctDeposito]?.readable;
  }

  isPctConsultazioneEnabled(): boolean {
    return this.isViewPCTConsultazione && this.descrittori?.[this.keyDescrittorePctConsultazione]?.writable;
  }

}
